
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 5H5a2 2 0 00-2 2v12a2 2 0 002 2h14a2 2 0 002-2V7a2 2 0 00-2-2h-1.5m-8 0h5M3 11h18","stroke":"#A4A8C0","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M11.91 13.182a.1.1 0 01.18 0l.768 1.557a.1.1 0 00.076.055l1.719.25a.1.1 0 01.055.17l-1.244 1.213a.1.1 0 00-.029.088l.294 1.712a.1.1 0 01-.145.106l-1.537-.808a.1.1 0 00-.094 0l-1.537.808a.1.1 0 01-.145-.106l.293-1.712a.1.1 0 00-.028-.088l-1.244-1.213a.1.1 0 01.055-.17l1.72-.25a.1.1 0 00.075-.055l.768-1.557z","fill":"#A4A8C0"}}),_c('mask',{attrs:{"id":"path-4-inside-1","fill":"#fff"}},[_c('rect',{attrs:{"x":"6","y":"2","width":"4","height":"6","rx":"1"}})]),_c('rect',{attrs:{"x":"6","y":"2","width":"4","height":"6","rx":"1","stroke":"#A4A8C0","stroke-width":"3","mask":"url(#path-4-inside-1)"}}),_c('mask',{attrs:{"id":"path-5-inside-2","fill":"#fff"}},[_c('rect',{attrs:{"x":"14","y":"2","width":"4","height":"6","rx":"1"}})]),_c('rect',{attrs:{"x":"14","y":"2","width":"4","height":"6","rx":"1","stroke":"#A4A8C0","stroke-width":"3","mask":"url(#path-5-inside-2)"}})])
          )
        }
      }
    